import React from "react";
import "./KRACard.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { FooterTabPosition } from "../../AppState/footerTabPosition";

type Props = {
  data?: {total?: number, open?: number, unassigned?: number, completed?: number, previousMonth?: number, mtd?: number};
  heading?: string,
  navigateTo?: string,
};

const KRACard: React.FC<Props> = ({data, heading, navigateTo}: Props): JSX.Element => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const fourCountHeadings = ["Overages", "Shortages", "Damages / Refusals", "On Hand", "Misdelivery"];
  const showFourCounts = fourCountHeadings.includes(heading || "");
  
  const onCardClick = () => {
    navigate(navigateTo!);
    dispatch(FooterTabPosition(1));
  };

  return (
 
      <button className="padding remove-style" type="button" onClick={() => onCardClick()}>
        <h4 className="card-header">{heading}</h4>

        <div className={`content-card${heading === "Cleared" ? " justify-content-reset" : ""}`}>

          {heading === "My Assignments" && (
            <>
              <div className="open-count">
                <p>Open</p>
                <h2>{data?.open ? data.open.toLocaleString('en-US') : "00"}</h2>
              </div>
              <br/>
              <br/>
              <br/>
              <div className="completed-count">
                <p>Completed</p>
                <h2>{data?.completed ? data.completed.toLocaleString('en-US') : "00"}</h2>
              </div>
              <div className="divider">
              </div>
              <div className="total-count">
                <p>Total</p>
                <h2>{data?.total ? data.total.toLocaleString('en-US') : "00"}</h2>
              </div>
            </>
          )}

          {showFourCounts && (
            <>
              <div className="open-count">
                <p>Open</p>
                <h2>{data?.open ? data.open.toLocaleString('en-US') : "00"}</h2>
              </div>
              <div className="unassigned-count">
                <p>Unassigned</p>
                <h2>{data?.unassigned ? data.unassigned.toLocaleString('en-US') : "00"}</h2>
              </div>
              <div className="completed-count">
                <p>Completed</p>
                <h2>{data?.completed ? data.completed.toLocaleString('en-US') : "00"}</h2>
              </div>
              <div className="divider"></div>
              <div className="total-count">
                <p>Total</p>
                <h2>{data?.total ? data.total.toLocaleString('en-US') : "00"}</h2>
              </div>
            </>
          )}

          {heading === "Cleared" && (
            <>
              <div className="mtd-count">
                <p>Month To Date (MTD)</p>
                <h2>{data?.mtd ? data.mtd.toLocaleString('en-US') : "00"}</h2>
              </div>
              <div className="previous-month-count">
                <p>Previous Month</p>
                <h2>{data?.previousMonth ? data.previousMonth.toLocaleString('en-US') : "00"}</h2>
              </div>
              <br />
              <br />
              <br />
              <br /> 
            </>
          )}

        </div>
      </button> 
    

  );
};

export default KRACard;
